import React from 'react'

import { GetServerSidePropsContext } from 'next'
import styled from 'styled-components/macro'
import { connect } from 'react-redux'
import useTranslation from 'next-translate/useTranslation'

import { Text } from '@/components/Text'
import { Path } from '@/components/Path'
import { PageLayout } from '@/components/Layout/PageLayout'

import { initializeStore } from '@/redux/store'
import { getSettings } from '@/redux/actions'

import { ColorsMap } from '@/utils/Theme'

import { StateInterface } from '@/types/State'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 14%;
  margin-bottom: 4rem;
`

const GDPR = ({ state }) => {
  const { t } = useTranslation('common')

  return (
    <PageLayout title={`GDPR | ${state.settings.name}`}>
      <Path pathLinks={[<span>{t('gdpr')}</span>]} />
      <Wrapper>
        <table>
          <tr>
            <td valign="top">
              <Text textColor={ColorsMap.primary} fontWeight="bold" fontSize="l" my="1rem">
                I. Základné ustanovenia
              </Text>
              <ol>
                <li dir="ltr">
                  <p dir="ltr">
                    Správcom osobných údajov podľa čl. 4 bod 7 nariadenia Európskeho parlamentu a Rady (EÚ) 2016/679 o
                    ochrane fyzických osôb pri spracovaní osobných údajov a o voľnom pohybe týchto údajov (ďalej len:
                    &quot;GDPR&quot;) je <span>SINTRA šport, s.r.o.</span>, <span>IČO:&nbsp;35935448</span> so sídlom{' '}
                    <span>Pluhová 2,</span>
                    <span>831 03 Bratislava</span>, Slovenská republika (ďalej len: &quot;správca&quot;).
                  </p>
                </li>
                <li dir="ltr">
                  <p dir="ltr">Kontaktné údaje správcu sú:</p>

                  <ul>
                    <li dir="ltr">
                      <p dir="ltr">adresa: SINTRA šport, s.r.o. - divízia Trenčín, Zlatovská 1962, 911 05 Trenčín</p>
                    </li>
                    <li dir="ltr">
                      <p dir="ltr">email: info@sintrasport.sk</p>
                    </li>
                    <li dir="ltr">
                      <p dir="ltr">telefón: +421 (0)32 65 29 110</p>
                    </li>
                  </ul>
                </li>
                <li dir="ltr">
                  <p dir="ltr">
                    Osobnými údajmi sú všetky informácie o identifikovanej alebo identifikovateľnej fyzickej osobe;
                    identifikovateľnou fyzickou osobou je fyzická osoba, ktorú možno priamo alebo nepriamo
                    identifikovať, najmä odkazom na určitý identifikátor, napríklad meno, identifikačné číslo, lokačné
                    údaje, sieťový identifikátor alebo pomocou jedného alebo viacerých špecifických faktorov,
                    fyziologických, genetických, mentálnych, ekonomických, kultúrnych alebo spoločenských.
                  </p>
                </li>
                <li dir="ltr">
                  <p dir="ltr">
                    Správca nemenoval / menoval poverenca pre ochranu osobných údajov. Kontaktné údaje poverenca sú:
                  </p>
                </li>
              </ol>
              <Text textColor={ColorsMap.primary} fontWeight="bold" fontSize="l" my="1rem">
                II. Zdroje a kategórie spracovávaných osobných údajov:
              </Text>
              <ol>
                <li dir="ltr">
                  <p dir="ltr">
                    Správca spracováva osobné údaje, ktoré ste mu poskytli alebo osobné údaje, ktoré správca získal na
                    základe plnenia Vašej objednávky.
                  </p>
                </li>
                <li dir="ltr">
                  <p dir="ltr">
                    Správca spracováva Vaše identifikačné a kontaktné údaje a údaje nevyhnutné pre plnenie zmluvy.
                  </p>
                </li>
              </ol>
              <Text textColor={ColorsMap.primary} fontWeight="bold" fontSize="l" my="1rem">
                III. Zákonný dôvod a účel spracovania osobných údajov:
              </Text>
              <ol>
                <li dir="ltr">
                  <p dir="ltr">Zákonným dôvodom spracovania osobných údajov je:</p>

                  <ul>
                    <li dir="ltr">
                      <p dir="ltr">plnenie zmluvy medzi Vami a správcom podľa čl. 6 odst. 1 písm. b) GDPR,</p>
                    </li>
                    <li dir="ltr">
                      <p dir="ltr">
                        oprávnený záujem správcu na poskytovaní priameho marketingu ( pre zasielanie obchodných oznámení
                        a newsletterov) podľa čl. 6 odst. 1 písm. f) GDPR,
                      </p>
                    </li>
                    <li dir="ltr">
                      <p dir="ltr">
                        Váš súhlas so spracovaním pre účely poskytovania priameho marketingu ( pre zasielanie obchodných
                        oznámení a newsletterov) podľa čl. 6 odst. 1 písm. a) GDPR v spojení s &sect; 7 odst. 2 zákona
                        č. 480/2004 Zb., o niektorých službách informačnej spoločnosti v prípade, že nedošlo k
                        objednávke tovaru alebo služby.
                      </p>
                    </li>
                  </ul>
                </li>
                <li dir="ltr">
                  <p dir="ltr">Účelom spracovania osobných údajov je:</p>

                  <ul>
                    <li dir="ltr">
                      <p dir="ltr">
                        vybavenie Vašej objednávky a výkon práv a povinností vyplývajúcich so zmluvného vzťahu medzi
                        Vami a správcom; pri objednávke sú vyžadované osobné údaje, ktoré sú nutné pre úspešné vybavenie
                        objednávky (meno a adresa, kontakt) Poskytnutie osobných údajov je nutným požiadavkom pre
                        uzatvorenie a plnenie zmluvy, bez poskytnutí osobných údajov nie je možné zmluvu uzavrieť alebo
                        ju plniť zo strany správcu.
                      </p>
                    </li>
                  </ul>
                </li>
                <li dir="ltr">
                  <p dir="ltr">
                    Zo strany správcu neprichádza / prichádza k automatickému individuálnemu rozhodovaniu v zmysle čl.
                    22 GDPR. S takým spracovaním ste poskytli svoj výslovný súhlas.
                  </p>
                </li>
              </ol>
              <Text textColor={ColorsMap.primary} fontWeight="bold" fontSize="l" my="1rem">
                IV. Doba uchovávania údajov
              </Text>
              <ol>
                <li dir="ltr">
                  <p dir="ltr">Správca uchováva osobné údaje:</p>

                  <ul>
                    <li dir="ltr">
                      <p dir="ltr">
                        po dobu nevyhnutnú k výkonu práv a povinností vyplývajúcich zo zmluvného vzťahu medzi Vami a
                        správcom a uplatňovania nárokov z týchto zmluvných vzťahov (po dobu 15 rokov od ukončenia
                        zmluvného vzťahu).
                      </p>
                    </li>
                    <li dir="ltr">
                      <p dir="ltr">
                        po dobu, kým je odvolaný súhlas so spracovaním osobných údajov pre účely marketingu, najdlhšie
                        &hellip;. rokov, ak sú osobné údaje spracovávané na základe súhlasu.
                      </p>
                    </li>
                  </ul>
                </li>
                <li dir="ltr">
                  <p dir="ltr">Po uplynutí doby uchovávania osobných údajov správca osobné údaje vymaže.</p>
                </li>
              </ol>
              <Text textColor={ColorsMap.primary} fontWeight="bold" fontSize="l" my="1rem">
                V. Príjemcovia osobných údajov (subdodávatelia správcu)
              </Text>
              <ol>
                <li dir="ltr">
                  <p dir="ltr">Príjemcovia osobných údajov sú osoby:</p>

                  <ul>
                    <li dir="ltr">
                      <p dir="ltr">podieľajúce sa na dodaní tovaru/služieb/realizácii platieb na základe zmluvy</p>
                    </li>
                    <li dir="ltr">
                      <p dir="ltr">
                        zaisťujúce služby prevádzkovania e-shopu a ďalšie služby v súvislosti s prevádzkovaním e-shopu
                      </p>
                    </li>
                    <li dir="ltr">
                      <p dir="ltr">zaisťujúce marketingové služby</p>
                    </li>
                  </ul>
                </li>
                <li dir="ltr">
                  <p dir="ltr">
                    Správca nemá v úmysle poskytnúť osobné údaje do tretej zeme (mimo EU) alebo medzinárodnej
                    organizácii. Príjemcovia osobných údajov v tretích zemiach sú poskytovatelia cloudových služieb.
                  </p>
                </li>
              </ol>
              <Text textColor={ColorsMap.primary} fontWeight="bold" fontSize="l" my="1rem">
                VI. Vaše práva
              </Text>
              <ol>
                <li dir="ltr">
                  <p dir="ltr">Za podmienok stanovených v GDPR máte:</p>

                  <ul>
                    <li dir="ltr">
                      <p dir="ltr">právo na prístup ku svojim osobným údajom podľa čl. 15 GDPR,</p>
                    </li>
                    <li dir="ltr">
                      <p dir="ltr">
                        právo na opravu osobných údajov podľa čl. 16 GDPR, poprípade obmedzenie spracovania podľa čl. 18
                        GDPR.
                      </p>
                    </li>
                    <li dir="ltr">
                      <p dir="ltr">právo na výmaz osobných údajov podľa čl. 17 GDPR.</p>
                    </li>
                    <li dir="ltr">
                      <p dir="ltr">právo podať námietku proti spracovávaniu podľa čl. 21 GDPR a</p>
                    </li>
                    <li dir="ltr">
                      <p dir="ltr">právo na prenesiteľnosť údajov podľa čl. 20 GDPR.</p>
                    </li>
                    <li dir="ltr">
                      <p dir="ltr">
                        právo odvolať súhlas so spracovaním písomne alebo elektronicky na adresu alebo email správcu
                        uvedený v čl. III týchto podmienok.
                      </p>
                    </li>
                  </ul>
                </li>
                <li dir="ltr">
                  <p dir="ltr">
                    Ďalej máte právo podať sťažnosť na Úrade pre ochranu osobných údajov v prípade, že sa domnievate, že
                    bolo porušené Vaše právo na ochranu osobných údajov.
                  </p>
                </li>
              </ol>
              <Text textColor={ColorsMap.primary} fontWeight="bold" fontSize="l" my="1rem">
                VII. Podmienky zabezpečenia osobných údajov
              </Text>
              <ol>
                <li dir="ltr">
                  <p dir="ltr">
                    Správca prehlasuje, že prijal všetky technické a organizačné opatrenia k zabezpečeniu osobných
                    údajov.
                  </p>
                </li>
                <li dir="ltr">
                  <p dir="ltr">
                    Správca prijal technické opatrenia k zabezpečeniu dátových úložísk a úložísk osobných údajov v
                    písomnej podobe.
                  </p>
                </li>
                <li dir="ltr">
                  <p dir="ltr">Správca prehlasuje, že k osobným údajom majú prístup len im poverené osoby.</p>
                </li>
              </ol>
              <Text textColor={ColorsMap.primary} fontWeight="bold" fontSize="l" my="1rem">
                VIII. Záverečné ustanovenia
              </Text>
              <ol>
                <li dir="ltr">
                  <p dir="ltr">
                    Odoslaním objednávky z internetového objednávkového formulára potvrdzujete, že ste zoznámený s
                    podmienkami ochrany osobných údajov a že ich v celom rozsahu prijímate.
                  </p>
                </li>
                <li dir="ltr">
                  <p dir="ltr">
                    S týmito podmienkami súhlasíte zaškrtnutím súhlasu prostredníctvom internetového formulára.
                    Zaškrtnutím súhlasu potvrdzujete, že ste zoznámený s podmienkami ochrany osobných údajov a že je v
                    celom rozsahu akceptujete.
                  </p>
                </li>
                <li dir="ltr">
                  <p dir="ltr">
                    Správca je oprávnený tieto podmienky zmeniť. Novú verziu podmienok ochrany osobných údajov zverejní
                    na svojich internetových stránkach a zároveň Vám zašle novú verziu týchto podmienok na Vašu
                    e-mailovou adresu, ktorú ste správcovi poskytli.
                  </p>
                </li>
              </ol>
              <p>&nbsp;</p>
              <p dir="ltr">Tieto podmienky nadobúdajú účinnosť dňom 25.05.2018.</p>
            </td>
          </tr>
        </table>
      </Wrapper>
    </PageLayout>
  )
}

const mapStateToProps = (state: StateInterface) => {
  return {
    state,
  }
}

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const reduxStore = initializeStore({})
  const { dispatch } = reduxStore

  const token = ctx.req.cookies.token || null

  await dispatch(getSettings({ token }))
  return { props: { initialReduxState: reduxStore.getState() } }
}

export default connect(mapStateToProps)(GDPR)

